module.exports = __webpack_public_path__ + "img/1455674697.142f4433.jpg";